import React from 'react';
import 'material-icons/iconfont/material-icons.css';
import './DriverCompanyGrade.scss';
import { GET_DRIVERCOMPANY_GRADE } from '../../../graphql/client/queries';
import { GetDriverCompanyGrade, GetDriverCompanyGradeVariables } from '../../../types/schemaTypes';
import { useQuery } from '@apollo/client/react';
import { Error } from '../../_common';
import { useStoreContext } from '../../App/StoreProvider';

export enum SortOrder {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING',
}

const DriverCompanyGrade = () => {
    const [state] = useStoreContext();
    const {
        carrierList: { carrierId },
    } = state;

    const variables: GetDriverCompanyGradeVariables = {
        id: carrierId ? carrierId : parseInt(localStorage.getItem('carrierId') || '0'),
    };

    const { error, data } = useQuery<GetDriverCompanyGrade, GetDriverCompanyGradeVariables>(
        GET_DRIVERCOMPANY_GRADE,
        {
            variables,
            fetchPolicy: 'network-only',
            context: {
                fetchOptions: {
                    signal: new AbortController().signal,
                },
            },
        },
    );

    if (error) {
        return <Error error={error} />;
    }
    if (
        data != null &&
        data.getDriverCompanyGrade != null &&
        data.getDriverCompanyGrade.grade != null &&
        data.getDriverCompanyGrade.grade !== 'Satisfactory'
    ) {
        return (
            <div>
                <div className="Grade-Container">Action Required | ISNET Company Profile Grade</div>
                <div className="Grade-Container-FontRed">
                    ISNET Company Grade is Not &quot;Satisfactory&quot;. Please take immediate action
                </div>
            </div>
        );
    }
    return <div></div>;
};

export default DriverCompanyGrade;
